import { Check } from "lucide-react";
import { useStations } from "../api";
import { StationLogo } from "./StationLogo";

/** One toggle per station; everything is on by default and switching one off leaves just that station out.
 *  `excluded` is the list of station slugs that are off. */
export function StationFilter({ excluded, onChange, label = "Stacje" }: {
  excluded: string[];
  onChange: (excluded: string[]) => void;
  label?: string;
}) {
  const { data } = useStations();
  const stations = data?.stations ?? [];
  const toggle = (slug: string) => {
    const next = excluded.includes(slug) ? excluded.filter((s) => s !== slug) : [...excluded, slug];
    if (next.length < stations.length) onChange(next); // never switch off every station
  };
  return (
    <fieldset className="stationfilter">
      <legend>
        {label}
        {excluded.length > 0 && (
          <button type="button" className="stationfilter__reset" onClick={() => onChange([])}>pokaż wszystkie</button>
        )}
      </legend>
      <div className="stationfilter__chips">
        {stations.map((s) => {
          const on = !excluded.includes(s.slug);
          return (
            <button key={s.slug} type="button" aria-pressed={on} className="stationchip" onClick={() => toggle(s.slug)}
              title={on ? `Pomiń ${s.name}` : `Dodaj z powrotem ${s.name}`}>
              <StationLogo slug={s.slug} size={20} />
              <span>{s.name}</span>
              <Check className="stationchip__check" size={15} strokeWidth={3} aria-hidden="true" />
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}

/** "a,b" in the URL <-> ["a","b"]. */
export const parseSlugs = (v: string | null) => (v ? v.split(",").filter(Boolean) : []);
export const joinSlugs = (list: string[]) => list.join(",");
